import { CompositionDetails } from "../composition-types";
import { compositionIds } from "../composition-ids";

export const jagatJalanda: CompositionDetails = {
    id: compositionIds.jagatJalanda,
    media: {
        youtubeVideoId: "T3uSoCz5_v0",
    },
    displayName: "Jagat Jalanda Rakh Le - Dr. Gurnam Singh Ji",
    taals: ["dadra"],
};
